import { Metamodel } from '@ardoq/api-types';
import { MetamodelContext } from 'metamodel/types';
import {
  getPopoverMessageFromContext,
  getWorkspaceNamesFromContext,
} from './utils';
import { WorkspaceNavigationPopoverContent } from './WorkspaceNavigationPopverContent';
import { dispatchAction } from '@ardoq/rxbeach';
import { createPopover, removePopover } from 'components/popover/actions';
import { type I18nLocale } from '@ardoq/i18n';
import { type ReactNode } from 'react';

type WorkspaceNavigationPopoverProps = {
  metamodel: Metamodel;
  context: MetamodelContext;
  children?: ReactNode;
  i18nLocale: I18nLocale;
};

const WorkspaceNavigationPopover = ({
  metamodel,
  context,
  children,
  i18nLocale,
}: WorkspaceNavigationPopoverProps) => {
  const popoverMessage = getPopoverMessageFromContext(context, i18nLocale);
  const workspaceNames = getWorkspaceNamesFromContext(metamodel, context);
  const popoverContent = WorkspaceNavigationPopoverContent({
    popoverMessage,
    workspaceNames,
  });
  return (
    <span
      style={{ display: 'inline-block', maxWidth: '100%' }}
      onMouseEnter={event =>
        dispatchAction(
          createPopover({
            popoverContent,
            targetElement: event.currentTarget,
          })
        )
      }
      onMouseLeave={() => dispatchAction(removePopover())}
    >
      {children}
    </span>
  );
};

export { WorkspaceNavigationPopover };
